<div class="select-wrapper" *ngIf="currentConfig && availableConfigs.length > 0">
	<select (change)="onChangeConfig($event.target.value)" class="select-dropdown professional-select bg-transparent forced">
		<option *ngFor="let configItem of availableConfigs" [value]="configItem.config" [selected]="currentConfig === configItem.config">
			{{ configItem.customerName }}{{ configItem.label ? ' (' + configItem.label + ')' : ' (' + configItem.allowedAccessLevel + ')' }}
		</option>
	</select>

</div>